import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { GlobalProvider } from "src/services/global";
import { BaseHelper } from "../baseHelper";

@Injectable({
  providedIn: "root",
})
export class AuthGuardService  {
  constructor(
    private router: Router,
    private g: GlobalProvider,
    private b: BaseHelper
  ) {}

  async canActivate(): Promise<boolean> {
    return true;
    if (this.g.loadingJwt) {
      const delay = (ms) => new Promise((_) => setTimeout(_, ms));
      const wat = await delay(2000).then(() => {
        this.g.loadingJwt = false;
        if (this.g.profile) {
          return true;
        } else {
          this.b.navigateRoot("/login");
          return false;
        }
      });
      return wat;
    } else {
      if (this.g.profile) {
        return true;
      } else {
        // this.b.clearJws();
        this.b.navigateRoot("/login");
        return false;
      }
    }
  }
}
